import LightingRiverHero from '@/components/special-effects/lighting-river';

export default function Home() {
  return <LightingRiverHero />;
}